import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';

@Component({
  selector: 'tt-payment-langs',
  templateUrl: './payment-langs.component.html',
  styleUrls: ['./payment-langs.component.css']
})
export class PaymentLangsComponent implements OnInit {
    paymentId;

    public grid?: GridOptions;

    constructor(private stateService: StateService) {
        this.paymentId = this.stateService.getStateParams()['payment_id'];
    }

    private loadGrid() {
        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w_paymentlangs_grid')
                .setLoadDataFunction({
                    method: 2744,
                    parameters: { payment_id: this.paymentId }
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    private async init() {
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}



//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('paymentLangs', {
//        templateUrl: 'views/components/views/paymentLangs/paymentLangs.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'ttGridFactory', function ($stateParams, ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let paymentId = $stateParams.payment_id;

//            vm.model = {
//                gridReady: true
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_paymentlangs_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            })
//                .setToolbar({ wrapping: true })
//                .setLoadDataFunction({
//                    method: 2744,
//                    parameters: { payment_id: paymentId }
//                });

//            // #endregion VARIABLES & DEFINITIONS

//        }]
//    });
//})();
